export default __webpack_public_path__ + "static/media/background-dark.dbfc19c6.jpg";